// component when repeat task is selected from dropdown
import { Box, Checkbox, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { weekdays } from '../../utils/dateUtils';

interface IRepeatTaskProps {
  repeatData: {
    days: number[];
  };
  handleRepeatChange: (_dayIndex: number) => void;
}

function RepeatTask({ repeatData, handleRepeatChange }: IRepeatTaskProps) {
  const handleCheckboxChange = (dayIndex: number) => {
    handleRepeatChange(dayIndex);
  };

  const { t } = useTranslation();

  return (
    <Box mt="16px">
      <Typography variant="meta" color="primary.main">
        {t('activity.assignActivity.repeatingTaskStartDateInput.label')}
      </Typography>
      <Box display="flex" flexDirection="row" flexWrap="wrap" mt="13px">
        {weekdays.map((day, index) => (
          <Box
            key={day}
            display="flex"
            alignItems="center"
            width={`calc(${100 / Math.min(weekdays.length, 4)}% - 12px)`}
            marginBottom="12px"
          >
            <Checkbox
              checked={repeatData.days[index] === 1}
              onChange={() => handleCheckboxChange(index)}
              sx={{
                padding: 0,
                margin: 0,
                color: '#6CA3AC',
                '&.Mui-checked': {
                  color: '#6CA3AC',
                },
              }}
              aria-labelledby="dont-show-again-label"
            />
            <Typography variant="bodyRegular" color="primary.main">
              {t(day)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default RepeatTask;
